var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"hls-player",attrs:{"id":"audio","crossorigin":_vm.crossorigin,"title":_vm.title,"controlsList":"nodownload"}},[_c('source',{attrs:{"type":"audio/mpeg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }